import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { animated, useSpring } from '@react-spring/web';

import { CloseButton } from '@app/shared/ui/atoms/Common';
import { TOP_BAR_HEADING_SPRING_CONFIG } from '@app/shared/constants/dailyEnergyDescription';
import { Page } from '@app/routes';

export function TopBar() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleCloseBtnClick = () => navigate(Page.DAILY_ENERGY);

  const headingSprings = useSpring({ ...TOP_BAR_HEADING_SPRING_CONFIG });

  return (
    <div className="flex items-center justify-between">
      <animated.h2 style={headingSprings} className="text-2xl font-semibold text-foreground">
        {t('daily_energy_description.energy_of_the_day')}
      </animated.h2>

      <CloseButton variant="dark" onClick={handleCloseBtnClick} />
    </div>
  );
}
